import axios from "axios";
import { ExampleTextListResponse } from "../types/apiResponseTypes";
import { FeedbackRequest, FeedbackResponse } from "../types/feedbackTypes";
import { GetUserResponse } from "../types/userTypes";
import { ExampleTextEntry } from "../types/commonTypes";

export async function getUserApi(): Promise<GetUserResponse> {
    return axios
        .get("/get_user", {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true
        })
        .then(res => {
            const data = res.data;

            const result: GetUserResponse = {
                userName: data.username,
                email: data.email,
                roles: data.roles
            };

            return result;
        })
        .catch(error => {
            throw error;
        });
}

export async function getExampleTextListApi(): Promise<ExampleTextEntry[]> {
    return axios
        .get("/example_text_list", {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true
        })
        .then(res => {
            const data: ExampleTextListResponse = res.data;

            return data.example_texts;
        })
        .catch(error => {
            throw error;
        });
}

export const feedbackApi = async (feedbackRequest: FeedbackRequest, logId: number): Promise<FeedbackResponse> => {
    return axios
        .put(`/logs/update/${logId}`, feedbackRequest, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true
        })
        .then(res => res.data)
        .catch(error => {
            throw error;
        });
};

export const logout = () => window.location.replace("/logout");

/**
 * Get SAS token for viewing files in citations
 */
export async function generateSasToken(filePath: string): Promise<string> {
    return axios
        .get("/content/sas", {
            params: { path: filePath },
            withCredentials: true
        })
        .then(res => res.data.sas_url)
        .catch(error => {
            throw error;
        });
}

/**
 * Get SAS token for viewing PDF files in citations
 */
export async function generatePDFSasToken(filePath: string, fileName: string, inline: boolean = false): Promise<string> {
    return axios
        .get("/content/pdf_sas", {
            params: { path: filePath, filename: fileName, inline },
            withCredentials: true
        })
        .then(res => res.data.sas_url)
        .catch(error => {
            throw error;
        });
}
